import { Action } from 'redux';
import { type IApiPaginate } from 'core/networks/Interfaces';

export const REQUEST_RECIPE_SUGGESTION_REQUEST = 'REQUEST_RECIPE_SUGGESTION_REQUEST';
export const REQUEST_RECIPE_SUGGESTION_SUCCESS = 'REQUEST_RECIPE_SUGGESTION_SUCCESS';
export const REQUEST_RECIPE_SUGGESTION_ERROR = 'REQUEST_RECIPE_SUGGESTION_ERROR';
export const RELOAD_RECIPE_SUGGESTION_REQUEST = 'RELOAD_RECIPE_SUGGESTION_REQUEST';
export const RELOAD_RECIPE_SUGGESTION_SUCCESS = 'RELOAD_RECIPE_SUGGESTION_SUCCESS';
export const CANCEL_RECIPE_SUGGESTION_REQUEST = 'CANCEL_RECIPE_SUGGESTION_REQUEST';

export const FETCH_RECIPE_SUGGESTION_REQUEST = 'FETCH_RECIPE_SUGGESTION_REQUEST';
export const FETCH_RECIPE_SUGGESTION_SUCCESS = 'FETCH_RECIPE_SUGGESTION_SUCCESS';
export const FETCH_RECIPE_SUGGESTION_ERROR = 'FETCH_RECIPE_SUGGESTION_ERROR';

export const FETCH_RECIPE_DETAIL_REQUEST = 'FETCH_RECIPE_DETAIL_REQUEST';
export const FETCH_RECIPE_DETAIL_SUCCESS = 'FETCH_RECIPE_DETAIL_SUCCESS';
export const FETCH_RECIPE_DETAIL_ERROR = 'FETCH_RECIPE_DETAIL_ERROR';

export const RESET_RECIPE_SUGGESSTION = 'RESET_RECIPE_SUGGESSTION';
export const UPDATE_FAVORITE = 'UPDATE_FAVORITE';

export const SEARCH_RECIPE_REQUEST = 'SEARCH_RECIPE_REQUEST';
export const SEARCH_RECIPE_SUCCESS = 'SEARCH_RECIPE_SUCCESS';
export const SEARCH_RECIPE_ERROR = 'SEARCH_RECIPE_ERROR'
export const RESET_SEARCH_RECIPE = 'RESET_SEARCH_RECIPE';

export const SEARCH_AI_RECIPE_REQUEST = 'SEARCH_AI_RECIPE_REQUEST';
export const SEARCH_AI_RECIPE_SUCCESS = 'SEARCH_AI_RECIPE_SUCCESS';
export const SEARCH_AI_RECIPE_ERROR = 'SEARCH_AI_RECIPE_ERROR'


export interface IRequestRecipeSuggestionRequest {
  ingredient_ids: number[];
  request_ingredients: string[];
  flavor_item_ids: number[];
  keyword?: string;
}
export interface IRequestRecipeSuggestionResponse {
  id: number;
  hashed_key?: string;
  lang_id?: number;
  created_at?: string;
  updated_at?: string;
}

export interface RequestRecipeSuggestionRequestAction extends 
  Action<typeof REQUEST_RECIPE_SUGGESTION_REQUEST> {
    payload: IRequestRecipeSuggestionRequest
  }

export interface RequestRecipeSuggestionSuccessAction extends
  Action<typeof REQUEST_RECIPE_SUGGESTION_SUCCESS> {
    payload: IRequestRecipeSuggestionResponse;
  }

export interface RequestRecipeSuggestionErrorAction extends 
  Action<typeof REQUEST_RECIPE_SUGGESTION_ERROR> {
    payload: Error;
  }

export interface IFetchRecipeSuggestionRequest {
  page: number;
  page_size: number;
  id: number;
  ignore_ids?: string;
}
export interface IFetchRecipeSuggestion {
  id: number;
  lang_id: number;
  name: string;
  thumbnail: string | null;
  video_id: string;
  recipe_request_id: any;
  content: {[key: string]: any};
  created_at: string;
  updated_at: string;
  is_favorite: boolean;
  youtube_videos: any[];
}
export type IFetchRecipeSuggestionResponse = 
  IFetchRecipeSuggestion |
  IApiPaginate<IFetchRecipeSuggestion>;

export interface IReloadRecipeSuggestionRequestAction extends 
  Action<typeof RELOAD_RECIPE_SUGGESTION_REQUEST> {
    payload: IFetchRecipeSuggestionRequest & {callback?: any}
  }

export interface IFetchRecipeSuggestionRequestAction extends 
  Action<typeof FETCH_RECIPE_SUGGESTION_REQUEST> {
    payload: IFetchRecipeSuggestionRequest
  }

export interface IFetchRecipeSuggestionSuccessAction extends
  Action<typeof FETCH_RECIPE_SUGGESTION_SUCCESS |  typeof RELOAD_RECIPE_SUGGESTION_SUCCESS> {
    payload: IFetchRecipeSuggestionResponse;
  }

export interface IFetchRecipeSuggestionErrorAction extends 
  Action<typeof FETCH_RECIPE_SUGGESTION_ERROR> {
    payload: Error;
  }

export interface IFetchRecipeDetailRequest {
  id: number;
  recipe_request_id?: number | null;
  callback?: (detail: IRecipeDetail) => void;
}
export type IRecipeDetail = IFetchRecipeSuggestion;
export type IFetchRecipeDetailResponse = IRecipeDetail;

export interface IFetchRecipeDetailRequestAction extends 
  Action<typeof FETCH_RECIPE_DETAIL_REQUEST> {
    payload: IFetchRecipeDetailRequest
  }

export interface IFetchRecipeDetailSuccessAction extends
  Action<typeof FETCH_RECIPE_DETAIL_SUCCESS> {
    payload: IFetchRecipeDetailResponse;
  }

export interface IFetchRecipeDetailErrorAction extends 
  Action<typeof FETCH_RECIPE_DETAIL_ERROR> {
    payload: Error;
  }

export type IResetRecipeAction = Action<typeof RESET_RECIPE_SUGGESSTION>

export type IUpdateFavorite = {
  id: number;
  is_favorite: boolean;
}
export interface IUpdateFavoriteAction extends
  Action<typeof UPDATE_FAVORITE> {
    payload: IUpdateFavorite;
  }

  export interface ISearchRecipeRequestAction extends 
  Action<typeof SEARCH_RECIPE_REQUEST> {
    payload: any;
  }

export interface ISearchRecipeSuccessAction extends
  Action<typeof SEARCH_RECIPE_SUCCESS> {
    payload: any;
  }

export interface ISearchRecipeErrorAction extends 
  Action<typeof SEARCH_RECIPE_ERROR> {
    payload: Error;
  }

export type IResetSearchRecipeAction = Action<typeof RESET_SEARCH_RECIPE>

export interface ISearchAiRecipeRequestAction extends 
Action<typeof SEARCH_AI_RECIPE_REQUEST> {
  payload: any;
}

export interface ISearchAiRecipeSuccessAction extends
Action<typeof SEARCH_AI_RECIPE_SUCCESS> {
  payload: any;
}

export interface ISearchAiRecipeErrorAction extends 
Action<typeof SEARCH_AI_RECIPE_ERROR> {
  payload: Error;
}
